/*
 * $Id:: StepTwo.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useState, useEffect } from 'react';

import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { ReactComponent as CheckedIcon } from '../../../../assets/images/check_box_24px.svg';
import { ReactComponent as UncheckedIcon } from '../../../../assets/images/check_box_outline_blank_24px.svg';
import Checkbox from '@material-ui/core/Checkbox';
import { t } from '../../../../providers';
import {useHistory} from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    stepTwoWrapper: {
        display: 'flex',
        flexFlow: 'column nowrap',
    },
    accountTypeRadio: {
        marginBottom: '25px',
    },
    radioTitle: {
        marginTop: '10px',
    },
    title: {
        fontWeight: theme.typography.titleFontWeight,
        fontSize: theme.typography.titleFontSize,
    },
    listIcon: {
        '& path': {
            fill: theme.palette.text.listgrey,
        },
    },
    typeTabs: {
        marginTop: '10px',
        display: 'flex',
        flexFlow: 'row wrap',
    },
    tabChip: {
        marginBottom: '10px',
        color: theme.palette.text.mainBlue,
        '&:not(:last-child)': {
            marginRight: '10px',
        },
    },
    selectedTab: {
        boxShadow: '0px 1px 8px rgba(0, 0, 0, 0.1), 0px 3px 4px rgba(0, 0, 0, 0.02), 0px 3px 3px rgba(0, 0, 0, 0.04)',
        backgroundColor: '#FAFAFA',
        border: '1px solid #ECEFF1',
    },
    formWrapper: {
        marginTop: '30px',
    },
    gridItem: {
        flex: '1 1 auto',
        marginBottom: '1.5rem',
    },
    fieldLabel: {
        fontWeight: theme.typography.titleFontWeight,
        fontSize: theme.typography.titleFontSize,
        color: '#546E7A',
    },
    textInput: {
        height: '2.5rem',
        width: '14rem',
        marginTop: '10px',
        '@media (max-width:600px)': {
            width: '12.5rem',
        },
    },
    buttonGroup: {
        marginTop: '40px',
    },
    submitButton: {
        minWidth: '82px',
    },
    checkboxLabel: {
        color: '#1E88E5',
        fontSize: '14px',
        textDecoration: 'underline',
        marginLeft: '4px',
        marginRight: '10px',
    }
}));

const StepTwo = ({ proceedToNextStep, accountTypes, stepData = {} }) => {
    console.log('stepData', stepData);
    const classes = useStyles();

    const [userType, setUserType] = useState(null);
    const [isPatentAttorney, setIsPatentAttorney] = useState(false);
    const [isPatentAttorneyError, setIsPatentAttorneyError] = useState(false);
    const history = useHistory();

    useEffect(() => {
        if (stepData.userType) {
            setUserType(stepData.userType);
            if(stepData.isPatentAttorney){
                setIsPatentAttorney(stepData.isPatentAttorney);
            }
        }

    }, [stepData]);

    useEffect(() => {
        return history.listen(() => {
            if (history.action === "POP") {
                history.push('/');
            }
        });
    });

    const handleAccountTypeChange = (event) => {
        if (event.target.value === accountTypes[0].key) {
            setIsPatentAttorney(false);
            setIsPatentAttorneyError(false);
        } else {
            setIsPatentAttorney(stepData.isPatentAttorney);
        }
        setUserType(event.target.value);
    };

    const handleIsPatentAttorneyChange = (event) => {
        if(stepData.isPatentAttorney){
          setIsPatentAttorney(event.target.checked);
        } else {
          setIsPatentAttorneyError(event.target.checked);
        }
    };

    const submitStep = (event) => {
        event.preventDefault();
        let submitStepData = { userType, isPatentAttorney };
        let canProceed = !!userType;
        if (!canProceed) return;
        proceedToNextStep(submitStepData);
    };

    const handleBack = () => {
        history.push(`/`);
    };

    return (
        <div className={classes.stepTwoWrapper}>
            <form onSubmit={submitStep} noValidate>
                <Typography className={classes.title}>{t('select.accurate.option.to.role')}</Typography>
                <FormControl component={'fieldset'} className={classes.accountTypeRadio}>
                    <Grid container>

                        <Grid item xs={12}>
                            <RadioGroup aria-label={'userType'} name={'userType'} value={userType} onChange={handleAccountTypeChange}>
                                {(accountTypes || []).map(({ key, value }, index) => {
                                    return (
                                        <div key={`${key}_${index}`}>
                                            <FormControlLabel className={classes.radioTitle} value={value} control={<Radio disableRipple />} label={t(key)} />
                                        </div>
                                    );
                                })}
                            </RadioGroup>
                        </Grid>

                        <Grid item xs={1}></Grid>
                        <Grid item xs={11}>
                            <FormControlLabel label={t('is.patent.attorney')}  control={
                                <Checkbox
                                    checked={isPatentAttorney}
                                    onChange={handleIsPatentAttorneyChange}
                                    name='isPatentAttorney'
                                    checkedIcon={<CheckedIcon />}
                                    icon={<UncheckedIcon />}
                                    disabled={userType !== 'representative' || stepData.isLegalEntity}
                                />}
                            />
                        </Grid>


                    </Grid>
                </FormControl>

                {isPatentAttorneyError && (
                    <Typography variant={'body2'} color={'error'}>
                        {t('not.recognized.as.patent.attorney')}
                    </Typography>
                )}

                <Grid container spacing={0} className={classes.buttonGroup}>
                    <Grid item>
                        <Button variant="outlined" type="button" className={classes.editButton} onClick={handleBack}>
                            {t('back')}
                        </Button>
                    </Grid>
                    {!!userType && (
                        <Grid item>
                            <Button variant={'outlined'} className={classes.submitButton} type={'submit'}>
                                {t('next')}
                            </Button>
                        </Grid>
                    )}
                </Grid>

            </form>
        </div>
    );
};

export default StepTwo;
